module.exports = __webpack_public_path__ + "img/NukedTV-Web_07.d329b129.png";